import React, { useState, useRef, useEffect } from 'react';
import { PiShareFatFill } from "react-icons/pi";
import './ActionButton.scss';

const Popup = ({ onClose }) => {
  return (
    <div className="popup">
      <div className="popup-header">
        <span>Cancel</span>
        <span>Please note</span>
        <span>Sure</span>
      </div>
      <div className="popup-content">
        <p>Hurry up, I've waited so long that the flowers have withered.</p>
        <p>I have paid, please wait, thank you</p>
        <p>Please pay as soon as possible after receiving the goods, thank you</p>
      </div>
      <div className="popup-footer">
        {/* Footer content if needed */}
      </div>
    </div>
  );
};

const ActionButton = () => {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      {showPopup && (
        <div className="backdrop" onClick={() => setShowPopup(false)} />
      )}
      <button className="action-button" onClick={() => setShowPopup(true)}>
      Is there a problem here? Send
        <PiShareFatFill className="icon" />
      </button>
      {showPopup && <Popup onClose={() => setShowPopup(false)} ref={popupRef} />}
    </>
  );
};

export default ActionButton;
